<template>
  <div class="proxy-play">
    <!-- Tab栏 -->
    <div class="tab-content">
          <!-- 父类 Tabs -->
          <div class="parent-tabs" v-if="categoryList && categoryList.length">
            <van-tabs v-model:active="activeParent" @change="onParentTabChange">
              <van-tab v-for="(cat, idx) in categoryList" :key="cat.id || idx" :title="cat.dcField2" :name="idx"></van-tab>
            </van-tabs>
          </div>

          <!-- 子类 Tabs（圆角按钮样式） -->
          <div class="child-tabs" v-if="subCategoryList && subCategoryList.length">
            <div class="child-tabs-buttons">
              <button v-for="(sub, sidx) in subCategoryList" :key="sub.id || sidx" :class="['child-item', activeChild === sidx ? 'active' : '']" @click="selectChild(sidx)">
                {{ sub.dcField2 || sub.name || sub.title }}
              </button>
            </div>
          </div>
        <!-- 充值金额选择 -->
        <div class="amount-section">

          <div class="amount-grid">
            <div v-for="amount in list" :key="amount.value" class="amount-item"
              :class="{ active: gameForm.id === amount.id }" @click="selectAmount(amount)">
              <van-image class="amount-thumb" :src="amount.depositPic" height="90px" fit="contain" />
               <div class="amount-value">{{ amount.configDesc }}</div>
                <div class="amount-price">￥{{ amount.ppAmount }}</div>
              <!-- 数量选择容器 -->
              <div v-show="gameForm.id === amount.id" style="padding-left: 6px;margin-top: 6px">
                <van-stepper theme="round" input-width="30px" button-size="22px" v-model="amount.quantity"
                  @change="(value) => quantityChange(value, amount.id)" @click.stop />
              </div>
            </div>
          </div>
          <!-- 底部操作栏 -->
          <div class="submit-section">
            <div class="bottom-left">
              <div class="bottom-item" @click="startChat">
                <van-icon name="chat-o" size="20" />
                <div class="bottom-text">客服</div>
              </div>
              <div class="bottom-item" @click="noticeClick">
                <van-icon name="volume-o" size="20" />
                <div class="bottom-text">教程</div>
              </div>
              <div class="bottom-item" @click="goToCart">
                <div style="position: relative;">
                  <van-icon name="shopping-cart-o" size="20" />
                  <van-badge v-if="cartTotalCount > 0" :content="cartTotalCount" style="position: absolute; top: -8px; right: -12px;" />
                </div>
                <div class="bottom-text">购物车</div>
              </div>
            </div>
            <div class="bottom-right">
              <div class="price-tag">¥{{ totalAmount || 0 }}</div>
              <van-button type="primary" size="small" :loading="submitLoading" @click="submitOrder">
                立即充值
              </van-button>
            </div>
          </div>
        </div>
      </div>

    <van-dialog v-model:show="showConfirmDialog" title="支付确认" show-cancel-button @confirm="confirmSubmit"
      @cancel="showConfirmDialog = false" confirm-button-text="确定" cancel-button-text="取消" :before-close="(action) => {
        if (action === 'confirm') {
          return true;
        }
      }
        ">
      <div style="text-align: center">确定支付这笔 ￥{{ totalAmount }} 选中服务吗？</div>
    </van-dialog>


    <van-popup v-model:show="showPayDialog" type="dialog" closeable :close-on-click-overlay="false"
      :style="{ width: '90%', margin: 'auto', borderRadius: '12px' }">
      <div class="pay-method-container">
        <!-- 价格 -->
        <div class="price-header">
          <span class="price-text">¥ {{ totalAmount }}</span>
        </div>

        <!-- 支付方式列表 -->
        <van-radio-group v-model="selectedPayMethod">
          <!-- 微信支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/weixin.png" alt="微信支付" />
            </div>
            <div class="pay-info">
              <div class="pay-name">微信支付</div>
              <div class="pay-desc">请在微信内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></div>
            </div>
            <van-radio name="wx" />
          </div>

          <!-- 支付宝支付 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/zhifubao.png" alt="支付宝" />
            </div>
            <div class="pay-info">
              <div class="pay-name">支付宝支付</div>
              <div class="pay-desc">请在浏览器内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="alipayTipClick"/></div>
            </div>
            <van-radio name="zfb" />
          </div>

          <!-- PP币余额 -->
          <div class="pay-item">
            <div class="pay-icon">
              <img src="@/assets/ppb.png" alt="BUFF" width="10px" height="10px" />
            </div>
            <div class="pay-info">
              <div class="pay-name">
                皮皮售余额 (¥ {{ userinfo.accountBalance }})
              </div>
              <div class="pay-desc">
                {{ userinfo.accountBalance < 0 ? "余额不足" : "" }} </div>
              </div>
              <van-radio name="ppb" />
            </div>
        </van-radio-group>

        <!-- 确认付款按钮 -->
        <div class="confirm-btn">
          <van-button type="primary" block @click="confirmPayment" :loading-text="showPayLoadingText"
            :loading="loading">
            确认付款
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="showIdChargeDialog" type="dialog"
      :style="{ width: '90%', margin: 'auto', borderRadius: '12px' }">
      <!-- 账号头像上传区域 -->
      <div class="avatar-upload-section" style="margin: 0px">
        <div class="section-title" style="margin-top: 1px">
          <span>账号头像</span>
          <span class="required-mark">*</span>
        </div>

        <div class="avatar-upload-container">
          <!-- 头像预览/上传区域 -->
          <div class="avatar-main">
            <div class="avatar-placeholder">
              <img v-if="previewImage" :src="previewImage" alt="头像预览" style="object-fit: contain" width="100%" />
            </div>
          </div>

          <!-- 操作按钮区域 -->
          <div class="avatar-actions">
            <van-button size="small" type="primary" plain icon="photograph" @click="openAvatarUpload"
              class="action-btn">
              上传
            </van-button>

            <van-button size="small" type="danger" plain icon="delete" @click="removeAvatar" class="action-btn">
              删除
            </van-button>
          </div>
        </div>
        <!-- 游戏ID信息 -->
        <van-cell-group>
          <van-field v-model="gameForm.gameId" label="游戏ID" placeholder="请输入游戏ID" required />
        </van-cell-group>

        <!-- 隐藏的上传组件 -->
        <van-uploader v-show="false" ref="avatarUploader" v-model="gameForm.avatar" :max-count="1"
          :after-read="onAvatarRead" accept="image/*" />


        <!-- 确认付款按钮 -->
        <div class="confirm-btn">
          <van-button type="primary" block @click="idCharge">
            确认充值
          </van-button>
        </div>
      </div>
    </van-popup>


    <van-popup :style="{ height: '70%', width: '100%' }" v-model:show="noticeShow">
      <div v-html="noticeData"></div>
    </van-popup>



    <div class="height-50"></div>
    <div class="height-50"></div>
    <van-tabbar route>
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/market" icon="search">市场</van-tabbar-item>
      <van-tabbar-item replace to="/stock" icon="shop-o">出售</van-tabbar-item>
      <van-tabbar-item replace to="/back" icon="after-sale">回收</van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay" icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { showToast } from "vant";
import request from "@/utils/request";
export default {
  name: "ProxyPlayPage",
  data() {
    return {
      userinfo: {},
      loading: false,
      showIdChargeDialog: false,
      totalAmount: 0,
      selectedPayMethod: '',
      pageNum: 1,
      pageSize: 10,
      submitLoading: false,
      showGamePicker: false,
      showServerPicker: false,
      showPayDialog: false,
      quantity: 1,
      // 游戏代充表单
      gameForm: {
        id: null,
        avatar: [],
        gameId: null,
        avatarUrl: null,
      },
      previewImage: "", // 存储预览图片的 URL

      list: [],
      showConfirmDialog: false,
      pendingOrderType: "", // 记录当前充值类型
      quantities: [],
      showPayLoadingText: '',
      appid: "wx7f7a74f218219cbc",
      noticeShow: false,
      noticeData: null,
      categoryList: [],
      subCategoryList: [],
      // 父/子 tab 控制
      activeParent: 0,
      activeChild: 0,
      cartItems: [], // 购物车商品列表
    };
  },
  created() {
    this.userinfo = this.$store.state.user.userInfo;
    this.pageNum = 1;
    this.getCategoryList();
    this.registerAuthCallBack();
    this.loadCartItems();
  },
  beforeRouteLeave(to, from, next) {
    // 离开代充模块时清空购物车（去购物车页面的情况除外）
    if (to.path !== '/cart') {
      this.clearCart();
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 从购物车返回时，恢复购物车数据
      if (from.path === '/cart') {
        vm.loadCartItems();
        vm.restoreSelectedItems();
      }
    });
  },
  computed: {
    cartTotalCount() {
      return this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
    }
  },
  methods: {
    weixinTipClick() {
       request.get("/front/chat/keywords", { params: { type: 5 } }).then((res) => {
      if (res.code == 200) {
        this.noticeData = this.processHTMLWithStyledImages(res.data[0].content);
        this.noticeShow = true;
      }
    });
    },
    alipayTipClick() {
       request.get("/front/chat/keywords", { params: { type: 6 } }).then((res) => {
      if (res.code == 200) {
        this.noticeData = this.processHTMLWithStyledImages(res.data[0].content);
        this.noticeShow = true;
      }
    });
    },
    getNotice() {
      request.get("/front/chat/keywords", { params: { type: 4 } }).then((res) => {
        if (res.code == 200) {
           this.noticeData = this.processHTMLWithStyledImages(res.data[0].content);
           this.noticeShow = true;
        }
      });
    },
    noticeClick() {
      this.getNotice();
    },
    confirmPayment() {
      this.showConfirmDialog = true;
    },
    quantityChange(value, itemId) {
      // 同步更新购物车
      this.updateCartQuantity(itemId, value);
    },
    // 获取特定项目的数量
    updateQuantityByItemId(itemId, quantity) {
      const itemIndex = this.list.findIndex(item => item.id === itemId);
      this.list[itemIndex].quantity = quantity;
    },
    // 购物车相关方法
    loadCartItems() {
      const cart = localStorage.getItem("cartItems");
      if (cart) {
        this.cartItems = JSON.parse(cart);
      }
    },
    saveCartItems() {
      localStorage.setItem("cartItems", JSON.stringify(this.cartItems));
    },
    addToCart(amount) {
      const existIndex = this.cartItems.findIndex(item => item.id === amount.id);
      if (existIndex > -1) {
        this.updateQuantityByItemId(amount.id, this.cartItems[existIndex].quantity);
      } else {
        this.cartItems.push({
          id: amount.id,
          quantity: 1,
          configType: amount.configType,
          ppAmount: amount.ppAmount,
          goldCoin: amount.goldCoin,
          depositPic: amount.depositPic,
          configDesc: amount.configDesc
        });
      }
      this.totalAmount = this.cartItems.reduce((sum, item) => sum + (item.ppAmount * item.quantity), 0);
      this.saveCartItems();
    },
    removeFromCart(itemId) {
      this.cartItems = this.cartItems.filter(item => item.id !== itemId);
      this.saveCartItems();
    },
    updateCartQuantity(itemId, quantity) {
      const existIndex = this.cartItems.findIndex(item => item.id === itemId);
      if (existIndex > -1) {
        if (quantity <= 0) {
          this.cartItems.splice(existIndex, 1);
        } else {
          this.cartItems[existIndex].quantity = quantity;
          this.calculateTotal();
        }
        this.saveCartItems();
      }
    },
    goToCart() {
      this.$router.push("/cart");
    },
    clearCart() {
      this.cartItems = [];
      localStorage.removeItem("cartItems");
    },
    restoreSelectedItems() {
      if (this.cartItems.length > 0) {
        // 恢复第一个购物车商品为当前选中状态
        const firstItem = this.cartItems[0];
        const listItem = this.list.find(item => item.id === firstItem.id);
        if (listItem) {
          this.selectAmount(listItem);
        }
        // 计算总价
        this.calculateTotal();
      }
    },
    calculateTotal() {
      this.totalAmount = this.cartItems.reduce((sum, item) => sum + (item.ppAmount * item.quantity), 0);
    },
    getCategoryList() {
       request.get("/front/deposit/getCateGoryList").then((res) => {
          if (res.code == 200) {
            this.categoryList = res.data;
            if (this.categoryList && this.categoryList.length > 0) {
              this.activeParent = 0;
              const first = this.categoryList[0];
              // 通过父类 configType 请求子类
              this.getSubCateGoryList(first.configType || first.type || first.id);
            }
          }
        });
    },
    getSubCateGoryList(parentType) {
       request.get(`/front/deposit/getSubCateGoryList/${parentType}`).then((res) => {
          if (res.code == 200) {
            this.subCategoryList = res.data;
            // 默认选中第一个子类并触发列表加载
            if (this.subCategoryList && this.subCategoryList.length > 0) {
              this.activeChild = 0;
              const firstSub = this.subCategoryList[0];
              this.getListBySub(firstSub);
            } else {
              this.list = [];
            }
          }
        });
    },
    onParentTabChange(index) {
      const idx = Number(index);
      if (this.categoryList && this.categoryList[idx]) {
        const parent = this.categoryList[idx];
        const parentType = parent.configType;
        this.getSubCateGoryList(parentType);
      }
    },
    onChildTabChange(index) {
      const idx = Number(index);
      if (this.subCategoryList && this.subCategoryList[idx]) {
        const sub = this.subCategoryList[idx];
        this.getListBySub(sub);
      }
    },
    selectChild(index) {
      const idx = Number(index);
      this.activeChild = idx;
      if (this.subCategoryList && this.subCategoryList[idx]) {
        this.getListBySub(this.subCategoryList[idx]);
      }
    },
    // 根据子类信息请求具体的金额/配置列表
    getListBySub(sub) {
       request.get(`/front/deposit/getListBySub/${sub.configType}`).then((res) => {
          if (res.code == 200) {
            this.list = res.data|| [];
            this.quantities = this.list.map((item) => ({ id: item.id, quantity: 1 }));
          }
        });
    },
    startChat() {
      (window.open('https://work.weixin.qq.com/kfid/kfc0afede0891281246'))
    },


    selectAmount(amount) {
      this.gameForm.id = amount.id;
      // 添加到购物车
      this.addToCart(amount);
    },

    async submitOrder() {

      if (this.cartItems.length == 0) {
        showToast("请选择游戏代充商品");
        return false;
      }
      this.showPayDialog = true;

    },
    idCharge() {
      if (!this.gameForm.avatarUrl) {
        showToast("请上传ID头像");
        return;
      }
      if (!this.gameForm.gameId) {
        showToast("请输入游戏ID");
        return;
      }
      this.showIdChargeDialog = false;
      this.showPayDialog = true;
    },
    //进行支付
    async confirmSubmit() {
      this.showConfirmDialog = false;
      const selectProduct = this.cartItems.map(item => {
        return {
          depositType: item.configType,
          ppAmount: item.ppAmount,
          quantity: item.quantity,
          configDesc: item.configDesc,
          depositPic: item.depositPic,
        }
      })
      
      const params = {
        payType: null,
        payScene: 11,
        gameList: selectProduct,
        totalAmount: this.totalAmount
      }

      if ("wx" == this.selectedPayMethod) {
        if (!this.isInWeixin()) {
          showToast("请在微信内打开网页支付");
          return;
        }
        this.loading = true;
        this.showPayLoadingText = "正在跳转微信支付..."
        params.payType = 1;
        //这是微信支付的
        await this.wxPay(params);
      } else if ("zfb" == this.selectedPayMethod) {
        if (this.isInWeixin()) {
          showToast("请在浏览器内打开网页支付");
          return;
        }
        this.loading = true;
        this.showPayLoadingText = "正在跳转支付宝支付..."
        params.payType = 2;
        //这是支付宝支付的
        await this.zfbPay(params);
      } else {
        this.loading = true;
        this.showPayLoadingText = "正在进行余额支付..."
        params.payType = 3;
        //这是余额支付的
        await this.ppbPay(params);
      }
    },
    async ppbPay(params) {
      // 调用购买API
      request
        .post("/front/pay/create", params)
        .then(async (res) => {
          if (res.code == 200) {
            showToast("支付成功！");
            let ur = await this.$store.dispatch("user/getUserInfo");
            if (ur.code == 200) {
              this.userinfo = res.data;
            }
            this.startChat();
            this.clearCart();
          } else {
            showToast(res.msg);
          }
        }).finally(() => {
          this.loading = false;
          this.showPayDialog = false;
        })
    },
    async zfbPay(params) {
      try {
        const result = await request.post("/front/pay/create", params);
        if (result.code === 200) {
          const payFormPage = result.data.pageRedirection;
          this.handleAlipaySubmit(payFormPage);
        }
      } catch (error) {
        showToast("支付失败，请重试!");
      } finally {
        this.loading = false;
        this.showPayDialog = false;
      }
    },

    handleAlipaySubmit(htmlForm) {
      // 创建一个临时容器
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlForm;

      // 获取表单元素
      const form = tempDiv.querySelector("form");
      if (form) {
        // 添加到页面并提交
        document.body.appendChild(form);
        form.submit();
      } else {
        showToast("支付失败!");
      }
    },
    async wxPay(params) {
      if (this.userinfo.openId) {
        params.openid = this.userinfo.openId;
        this.wxPayment(params)
      } else {
        // 将state数据编码为JSON字符串并进行URL编码
        const stateParam = encodeURIComponent(JSON.stringify(params));
        // console.log(stateParam);
        // 使用正确的重定向URL格式
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid
          }&redirect_uri=${encodeURIComponent(
            `https://www.ppstandoff2.com/proxyPlay`
          )}&response_type=code&scope=snsapi_base&state=${stateParam}#wechat_redirect`;
      }
    },
    async wxPayment(params) {
      const res_createOrder = await request.post(
        "/front/pay/create", params);
      if (res_createOrder.code == 200) {
        if (typeof WeixinJSBridge === "undefined") {
          showToast("请在微信中打开");
        } else {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: res_createOrder.data.payParams.appId,
              timeStamp: res_createOrder.data.payParams.timeStamp,
              nonceStr: res_createOrder.data.payParams.nonceStr,
              package: res_createOrder.data.payParams.packageVal,
              signType: res_createOrder.data.payParams.signType,
              paySign: res_createOrder.data.payParams.paySign,
            },
            async (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                showToast("支付成功");
                this.loading = false;
                this.showPayDialog = false;
                this.startChat();
                this.clearCart();
              }
              else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                showToast("用户取消支付");
                this.loading = false;
                this.showPayDialog = false;
              }
              else {
                showToast("支付失败");
                this.loading = false;
                this.showPayDialog = false;
              }
            }
          );
        }
      }
    },
    async registerAuthCallBack() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get("code");
      const state = url.searchParams.get("state");
      const payScene = url.searchParams.get("payScene");
      console.log(`code=${code}, state=${state}, payScene=${payScene}`)
      if (code) {
        console.log("微信授权回调")
        try {
          // 先解码，再解析JSON
          const decodedState = decodeURIComponent(state);
          const stateData = JSON.parse(decodedState);
          console.log(stateData);
          const res_openid = await request.get(
            "/front/auth/wechat/auth/callback",
            {
              params: { code: code },
            }
          );
          let openid = res_openid.data;
          stateData.openid = openid
          this.userinfo.openId = openid;
          this.wxPayment(stateData);
        } catch (error) {
          console.error("解析state参数失败:", error);
          showToast("微信支付失败,请稍后重试");
        }
      }
      if (payScene) {
        this.startChat();
      }
    },
    isInWeixin() {
      const judgeIfWeXin = typeof WeixinJSBridge == "undefined";
      return !judgeIfWeXin;
    },
    // 头像上传后的处理
    openAvatarUpload() {
      this.$refs.avatarUploader.chooseFile();
    },

    // 头像上传后处理
    onAvatarRead(file) {
      this.gameForm.avatarName = file.file ? file.file.name : "已选择头像";
      // 创建 FileReader 来读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        showToast("头像上传成功");
      };
      reader.readAsDataURL(file.file);
      this.gameForm.avatar = [file.file];
      this.gameForm.avatarUrl = null;
      //上传图像
      this.uploadUserAvatar();
    },

    // 删除头像
    removeAvatar() {
      this.gameForm.avatar = [];
      this.previewImage = "";
      showToast("头像已删除");
    },

    // 选择预设头像
    selectPresetAvatar(avatar) {
      this.gameForm.selectedPresetAvatar = avatar;
      // 清除上传的头像
      this.gameForm.avatar = [];
    },

    async uploadUserAvatar() {
      let formData = new FormData();
      formData.append(
        "file",
        this.gameForm.avatar.length > 0 ? this.gameForm.avatar[0] : null
      );
      let uploadResponse = await request.post(
        "/common/other/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (uploadResponse.code == 200) {
        this.gameForm.avatarUrl = uploadResponse.url;
      }
    },
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },
  },
};
</script>

<style scoped>
.proxy-play {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 160px;
}

.tab-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #323233;
  margin: 20px 0 12px 0;
  padding-left: 4px;
}

/* 金额选择样式 */
.amount-section {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 230px);
}

.amount-grid {
  display: grid;
  /* 强制始终显示 3 列，项等分容器宽度 */
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  overflow: auto;
  justify-items: center;
}

/* 响应式设计 - 小屏调整间距 */
@media (max-width: 375px) {
  .amount-grid {
    gap: 6px;
  }
  .amount-item {
    padding: 8px;
  }
}

/* 追加一些项的自适应样式，保证每格在窄屏上仍能正常展示 */
.amount-item {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 6px;
  background: #fff;
  border-radius: 8px;
}

.amount-item .amount-value {
  font-size: 14px;
  margin-top: 6px;
}

.amount-item .amount-price {
  font-size: 13px;
  color: #ee0a24;
}
  
  /* 图片缩略容器，保持图片纵横比不变且居中显示 */
  .amount-thumb {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .amount-thumb img {
    width: auto;
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }

  /* 子类圆角按钮样式 */
  .child-tabs-buttons {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 8px 0 12px 0;
    scroll-snap-type: x mandatory;
    white-space: nowrap;
  }
  .child-item {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 84px;
    padding: 6px 12px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #ebedf0;
    cursor: pointer;
    white-space: nowrap;
    font-size: 12px;
    scroll-snap-align: center;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .child-item.active {
    background: #1989fa;
    color: #fff;
    border-color: #1989fa;
  }

@media (max-width: 320px) {
  .amount-grid {
    gap: 4px;
  }
  .amount-item {
    padding: 6px;
  }
  .amount-thumb img {
    height: 70px !important;
  }
  .amount-value {
    font-size: 9px;
  }
  .amount-price {
    font-size: 9px;
  }
}

.amount-item {
  background: white;
  border: 2px solid #ebedf0;
  height: auto;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.amount-item.active {
  border-color: #1989fa;
  background-color: #f0f8ff;
}

.amount-value {
  font-size: 10px;
  font-weight: 600;
  color: #323233;
  text-align: center;
  padding: 0px;
}

.amount-price {
  font-size: 10px;
  font-weight: 300;
  color: #ee0a24;
  font-weight: bold;
  text-align: center;
  padding: 0px;
}

/* 商品选择样式 */
.product-section {
  margin: 20px 0;
}

.product-list {
  margin-top: 12px;
}

.product-item {
  background: white;
  border: 2px solid #ebedf0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.product-item.active {
  border-color: #1989fa;
  background-color: #f0f8ff;
}

.product-info {
  flex: 1;
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 4px;
}

.product-desc {
  font-size: 12px;
  color: #969799;
}

.product-price {
  font-size: 16px;
  color: #ee0a24;
  font-weight: 600;
}

/* 提交按钮样式 */
/* .submit-section {
  margin-top: 10px;
  bottom: 0px;
} */
.submit-section {
  position: fixed;
  bottom: 60px;
  /* tabbar的高度，根据实际情况调整 */
  left: 0;
  right: 0;
  padding: 10px 16px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.bottom-left {
  display: flex;
  gap: 20px;
}

.bottom-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.bottom-text {
  font-size: 12px;
  color: #333;
  margin-top: 4px;
}

.bottom-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.price-tag {
  font-size: 16px;
  font-weight: bold;
  color: #ee0a24;
}

.bottom-right .van-button {
  border-radius: 20px;
  padding: 6px 16px;
}

/* 保持 tab-content 在小屏上的内边距 */
@media (max-width: 375px) {
  .tab-content {
    padding: 12px;
  }
}

/* 头像相关样式 */
.avatar-section {
  margin: 20px 0;
}

.avatar-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.avatar-upload-section {
  margin: 20px 0;
}

.avatar-upload-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.avatar-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
  cursor: pointer;
}

/* 头像预览样式 */
.avatar-preview {
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.3s ease;
}

.avatar-preview:hover {
  transform: scale(1.05);
}

.avatar-image {
  border: 3px solid #f0f0f0;
  transition: all 0.3s ease;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 50%;
}

.avatar-preview:hover .avatar-overlay {
  opacity: 1;
}

.overlay-text {
  color: white;
  font-size: 12px;
  margin-top: 4px;
}

/* 头像占位符样式 */
.avatar-placeholder {
  width: 80px;
  height: 80px;
  border: 2px dashed #dcdee0;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.avatar-placeholder:hover {
  border-color: #1989fa;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: scale(1.05);
}

.avatar-placeholder::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent);
  transform: rotate(45deg);
  transition: all 0.6s ease;
  opacity: 0;
}

.avatar-placeholder:hover::before {
  opacity: 1;
  animation: shimmer 1.5s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }

  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

.placeholder-icon {
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.avatar-placeholder:hover .placeholder-icon {
  transform: scale(1.1);
}

.placeholder-text {
  text-align: center;
}

.main-text {
  font-size: 14px;
  font-weight: 500;
  color: #646566;
  margin-bottom: 2px;
}

.sub-text {
  font-size: 12px;
  color: #969799;
}

/* 操作按钮样式 */
.avatar-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.action-btn {
  min-width: 80px;
  border-radius: 20px;
  font-size: 13px;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.3);
}

/* 上传提示样式 */
.upload-tips {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #f7f8fa;
  border-radius: 6px;
  font-size: 12px;
  color: #646566;
}

/* 必填标记样式 */
.required-mark {
  color: #ee0a24;
  margin-left: 4px;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .avatar-upload-container {
    padding: 16px;
  }

  .avatar-main {
    margin-bottom: 12px;
  }

  .action-btn {
    min-width: 70px;
    font-size: 12px;
  }
}

.preset-avatars {
  margin-top: 20px;
}

.preset-title {
  font-size: 14px;
  color: #646566;
  margin-bottom: 12px;
}

.preset-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}

.preset-avatar {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.preset-avatar.active {
  border-color: #1989fa;
  transform: scale(1.1);
}

.preset-avatar:hover {
  transform: scale(1.05);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .preset-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.avatar-preview-section {
  margin: 16px 0;
}

.avatar-preview-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f7f8fa;
  border-radius: 8px;
}

.remove-btn {
  margin-left: auto;
}

.pay-method-container {
  padding: 20px;
  background: white;
  border-radius: 12px;
}

.price-header {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.pay-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.pay-item:last-child {
  border-bottom: none;
}

.pay-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pay-icon {
  width: 40px;
  height: 40px;
  /* border-radius: 50%; */
  overflow: hidden;
  /* background: #f5f5f5; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.pay-info {
  flex: 1;
  margin-left: 12px;
}

.pay-name {
  font-size: 16px;
  color: #333;
}

.pay-desc {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.confirm-btn {
  margin-top: 20px;
}
</style>
